import { Button, Flex, Icon, Image, Text } from "@simplybusiness/mobius";
import { lock } from "@simplybusiness/icons";

interface CombinedPaymentButtonProps {
  buttonText: string;
  poweredByStripeLogo: string;
  onClick: () => void;
}

export const CombinedPaymentButton = ({
  buttonText,
  poweredByStripeLogo,
  onClick,
}: CombinedPaymentButtonProps) => (
  <Flex flexDirection="column">
    <Button
      className="mobius-payment-summary__checkout-button combined-payment-page-sticky"
      size="md"
      data-testid="open-payment-drawer-btn"
      onClick={onClick}
    >
      {buttonText}
    </Button>
    <Flex flexDirection="row" alignItems="center" justifyContent="center">
      <Icon
        icon={lock}
        className="mobius-call-to-action_secure-checkout-icon"
      />
      <Text className="mobius-call-to-action_secure-checkout-text">
        Secure Checkout
      </Text>
      <Image
        className="powered-by-stripe-logo"
        src={poweredByStripeLogo}
        alt="Powered by Stripe"
      />
    </Flex>
  </Flex>
);
